var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.045,
    height: 19.069,
    viewBox: "0 0 19.045 19.069",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#208ce1;stroke-linejoin:round;stroke-width:1.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-37.606,191.135q0-.619,0-1.237c0-.394,0-.788,0-1.181,0-.277.144-.436.375-.439s.391.166.391.447q0,1.8,0,3.607c0,.041-.006.082-.01.133a.828.828,0,0,1-.125.019h-3.621c-.191,0-.367-.061-.409-.258a.491.491,0,0,1,.076-.379.557.557,0,0,1,.374-.137c.695-.013,1.389-.006,2.084-.006h.264a7.384,7.384,0,0,0-1.349-1.347,7.787,7.787,0,0,0-5.672-1.652,7.948,7.948,0,0,0-7.017,6.179,7.958,7.958,0,0,0,4.974,9.278,7.957,7.957,0,0,0,10.6-5.713,13.984,13.984,0,0,0,.207-1.711c.03-.3.143-.45.387-.449s.381.168.38.475a8.777,8.777,0,0,1-6.876,8.477,8.763,8.763,0,0,1-10.366-6.386A8.762,8.762,0,0,1-46.4,188.125a8.536,8.536,0,0,1,8.663,2.93l.08.093Z",
    transform: "translate(53.995 -187.14)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/reset_icon.7de5a41866e7d99a0cb9fc17764bf943.svg";
export { ForwardRef as ReactComponent };